import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { getDeviceInventoryCount } from './-query/api';
import { SearchSchema } from './-zod-schema';

export const Route = createFileRoute('/_staff/devices/_list/inventories/')({
  validateSearch: zodValidator(SearchSchema),
  loader: getDeviceInventoryCount,
});
